export default __webpack_public_path__ + "assets/d6c26008b9b1fe61ff939542d568fd44.jpg";